var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');
var {
  AppRegistry,
  View,
  Image,
  Platform,
  findNodeHandle
} = ReactNative;

var Globals = require('../Globals');
var Animated = require('./Animated');

var ANIM_DURATION = 300;

var NAV_BAR_ANIM_OFFSET_START = 400;

var Navigator = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      style: {position:'absolute', left:0, right:0, bottom:0, top:0, flexDirection:'column'},
      navigationBar : null,
      initialRoute : null,
      renderScene : (route, theNav) => {},
      onWillFocus : (route) => {},
      onDidFocus : (route) => {},
    }
  },

  _isAnimating : false,
  _leftOffsets : [],
  _rightOffsets : [],
  getInitialState : function()
  {
    var navBar = null;
    if( this.props.navigationBar != null )
    {
      var newProps = {
        nav:this
      }
      if( this.props.initialRoute != null )
      {
        newProps.initialRouteStack = [this.props.initialRoute];
      }
      navBar = React.cloneElement(
        this.props.navigationBar,
        newProps
      )
    }
    var routeStack = [];
    if( this.props.initialRoute != null )
    {
      this._leftOffsets.push(new Animated.Value(0));
      this._rightOffsets.push(new Animated.Value(0));
      routeStack.push(this.props.initialRoute);
    }

    return {
      navBar,
      routeStack,
    }
  },

  componentDidMount : function()
  {
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.navigationBar !== 'undefined' )
    {
      var thisThing = this;
      var newProps = {
        nav:this
      }
      if( this.props.initialRoute != null )
      {
        newProps.initialRouteStack = [this.props.initialRoute];
      }
      this.setState(
        {
          navBar : this.props.navigationBar ? React.cloneElement(
            this.props.navigationBar,
            newProps
          ) : null
        }
      )
    }
  },

  immediatelyResetRouteStack : function(routeStack)
  {
    this._isAnimating = false;
    this._leftOffsets = [];
    this._rightOffsets = [];
    for( var i = 0; i < routeStack.length; i++ )
    {
      this._leftOffsets.push(new Animated.Value(0));
      this._rightOffsets.push(new Animated.Value(0));
    }
    this.setState({routeStack})
    if( this._navBar )
    {
      if( this._navBar._isMounted ) this._navBar.setRouteStack(routeStack);
    }
  },

  resetTo : function(route)
  {
    this.immediatelyResetRouteStack([route]);
  },

  popToTop : function()
  {
    this.immediatelyResetRouteStack([]);
  },

  push : function(newRoute)
  {
    if( this._isAnimating ) return;
    this._isAnimating = true;

    var routeStack = this.state.routeStack;
    routeStack.push(newRoute);
    if( this._navBar && this._navBar._isMounted ) this._navBar.push(newRoute);

    // console.log("animss push ", newRoute, routeStack)

    this._shouldStartPushAnim = true;
    this._leftOffsets.push(new Animated.Value(this._width));
    this._rightOffsets.push(new Animated.Value(-this._width));

    this.setState({routeStack});

    var thisThing = this;
    setTimeout(()=>
    {
      thisThing.doPushAnim();
    }, 10)
  },

  pop : function()
  {
    if( this._isAnimating ) return;
    this._isAnimating = true;
    if( this._navBar ) this._navBar.pop();

    var thisThing = this;
    thisThing.props.onWillFocus(thisThing.state.routeStack[thisThing.state.routeStack.length-2]);
    Animated.timing(this._rightOffsets[this._rightOffsets.length-1],{toValue:-this._width, duration:ANIM_DURATION}).start(()=>
    {
    })
    Animated.timing(this._leftOffsets[this._leftOffsets.length-1],{toValue:this._width, duration:ANIM_DURATION}).start(()=>
    {
      thisThing.props.onDidFocus(thisThing.state.routeStack[thisThing.state.routeStack.length-2]);
      setTimeout(()=>
      {
        var routeStack = thisThing.state.routeStack;
        routeStack.pop();

        thisThing._rightOffsets.pop();
        thisThing._leftOffsets.pop();
        thisThing._isAnimating = false;

        thisThing.setState({routeStack});
      }, 10)
    })
  },

  replace: function(topRoute)
  {
    var routeStack = this.state.routeStack;
    if( routeStack.length <= 0 )
    {
      this._rightOffsets = [new Animated.Value(0)];
      this._leftOffsets = [new Animated.Value(0)];
      routeStack = [topRoute];
    }
    else
    {
      routeStack[routeStack.length-1] = topRoute;
    }

    if( this._navBar && this._navBar._isMounted ) this._navBar.replace(topRoute);
    this.setState({routeStack});
  },

  doPushAnim : function()
  {
    if( !this._shouldStartPushAnim ) return;
    this._shouldStartPushAnim = false;
    var thisThing = this;

    thisThing.props.onWillFocus(thisThing.state.routeStack[thisThing.state.routeStack.length-1]);
    Animated.timing(thisThing._rightOffsets[thisThing._rightOffsets.length-1],{toValue:0, duration:ANIM_DURATION}).start(()=>
    {
      thisThing.props.onDidFocus(thisThing.state.routeStack[thisThing.state.routeStack.length-1]);
    })
    Animated.timing(thisThing._leftOffsets[thisThing._leftOffsets.length-1],{toValue:0, duration:ANIM_DURATION}).start(()=>
    {
      thisThing._isAnimating = false;
    })
  },

  setNavBar : function(navBar)
  {
    this._navBar = navBar;
  },

  render: function()
  {
    if( this.state.routeStack.length <= 0 ) return null;

    var currentIndex = this.state.routeStack.length-1;
    var currentRoute = this.state.routeStack[currentIndex];

    var thisThing = this;

    return (
      <View style={[this.props.style, {flexDirection:'column'}]} onLayout={(evt)=>
      {
        if( thisThing._width != evt.nativeEvent.layout.width )
        {
          thisThing._width = evt.nativeEvent.layout.width;
          thisThing.forceUpdate();
        }
      }}>
        <View style={{position:'relative', flex:1, backgroundColor:'transparent', maxWidth:thisThing._width, alignSelf:'stretch', overflow:'hidden'}} onLayout={(evt)=>
          {
            // console.log("thisThing._width",evt.nativeEvent.layout)
          }}>
        {
          thisThing.state.routeStack.map((route, index) =>
          {
            var otherStyle = {};
            if( typeof thisThing._width !== 'undefined' )
            {
              otherStyle.width = thisThing._width;
              otherStyle.maxWidth = thisThing._width;
            }
            else
            {
              otherStyle.width = '100%';
              otherStyle.right = thisThing._rightOffsets[index];
            }
            return <Animated.View key={"route-"+index}
              style={
                [{
                  position:'absolute',
                  top:0,
                  bottom:0,
                  left:thisThing._leftOffsets[index],
                  overflow:'hidden',
                }, otherStyle]} onLayout={(evt)=>
                {
                  // console.log("animss - layout - "+index, thisThing.state.routeStack, evt.nativeEvent.layout.width)
                }}>
                {thisThing.props.renderScene(route, thisThing)}
            </Animated.View>
          })
        }
        </View>
        {
          this.state.navBar != null ?
            <View style={{pointerEvents:'box-none', position:'absolute', left:0, right:0, top:0, height:Globals.ACTION_BAR_HEIGHT, flexDirection:'row'}}>
              {this.state.navBar}
            </View>
          : null
        }
      </View>
    )
  }
});

Navigator.NavigationBar = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      style: {},
      nav:null,
      routeMapper:null,
      onWillFocus : (route) => {},
      onDidFocus : (route) => {}
    }
  },

  _leftOffsets : [],
  _rightOffsets : [],
  _opacities : [],
  getInitialState : function()
  {
    var routeStack = JSON.parse(JSON.stringify(this.props.nav.state.routeStack));
    this._leftOffsets = [];
    this._rightOffsets = [];
    this._opacities = [];
    for( var i = 0; i < routeStack.length; i++ )
    {
      this._opacities.push(new Animated.Value(1, "opa 0"));
      this._leftOffsets.push(new Animated.Value(0));
      this._rightOffsets.push(new Animated.Value(0));
    }
    return {
      routeStack
    }
  },

  _isMounted: false,
  componentDidMount : function()
  {
    this._isMounted = true;
    this.props.nav.setNavBar(this);
  },

  componentWillUnmount : function()
  {
    this._isMounted = false;
  },

  setNav : function(nav)
  {
    this.setState({nav})
  },

  push : function(newRoute)
  {
    var routeStack = this.state.routeStack;
    routeStack.push(JSON.parse(JSON.stringify(newRoute)));
    this._shouldStartPushAnim = true;
    for( var i = 0; i < routeStack.length; i++ )
    {
      if( i >= (routeStack.length-1) )
      {
        if( typeof this._leftOffsets[i] === 'undefined' ) this._leftOffsets.push(new Animated.Value(NAV_BAR_ANIM_OFFSET_START));
        if( typeof this._rightOffsets[i] === 'undefined' ) this._rightOffsets.push(new Animated.Value(-NAV_BAR_ANIM_OFFSET_START));
        if( typeof this._opacities[i] === 'undefined' ) this._opacities.push(new Animated.Value(0, "opa "+i));
      }
      else if( i >= (routeStack.length-2) )
      {
        if( typeof this._leftOffsets[i] === 'undefined' ) this._leftOffsets.push(new Animated.Value(0));
        if( typeof this._rightOffsets[i] === 'undefined' ) this._rightOffsets.push(new Animated.Value(0));
        if( typeof this._opacities[i] === 'undefined' ) this._opacities.push(new Animated.Value(1, "opa "+i));
      }
      else
      {
        if( typeof this._leftOffsets[i] === 'undefined' ) this._leftOffsets.push(new Animated.Value(0));
        if( typeof this._rightOffsets[i] === 'undefined' ) this._rightOffsets.push(new Animated.Value(0));
        if( typeof this._opacities[i] === 'undefined' ) this._opacities.push(new Animated.Value(0, "opa "+i));
      }
    }

    this.setState({routeStack});

    var thisThing = this;
    setTimeout(()=>
    {
      thisThing.doPushAnim();
    }, 10)
  },

  pop : function()
  {
    var thisThing = this;
    // Animated.timing(this._rightOffsets[this._rightOffsets.length-1],{toValue:-NAV_BAR_ANIM_OFFSET_START, duration:ANIM_DURATION}).start(()=>
    // {
    // })
    // Animated.timing(this._leftOffsets[this._leftOffsets.length-1],{toValue:NAV_BAR_ANIM_OFFSET_START, duration:ANIM_DURATION}).start(()=>
    // {
    // })
    Animated.timing(this._opacities[this._opacities.length-1],{toValue:0, duration:ANIM_DURATION/2}).start(()=>
    {
      Animated.timing(this._opacities[this._opacities.length-2],{toValue:1, duration:ANIM_DURATION/2}).start(()=>
      {
        setTimeout(()=>
        {
          var routeStack = thisThing.state.routeStack;
          routeStack.pop();

          thisThing._rightOffsets.pop();
          thisThing._leftOffsets.pop();
          thisThing._opacities.pop();

          thisThing.setState({routeStack});
        }, 10)
      })
    })
  },

  setRouteStack : function(routeStack)
  {
    this._leftOffsets = [];
    this._rightOffsets = [];
    this._opacities = [];
    for( var i = 0; i < routeStack.length; i++ )
    {
      this._leftOffsets.push(new Animated.Value(0));
      this._rightOffsets.push(new Animated.Value(0));
      this._opacities.push(new Animated.Value(i == (routeStack.length-1) ? 1 : 0, "opa "+i));
    }
    this.setState({routeStack:JSON.parse(JSON.stringify(routeStack))});
  },

  replace : function(topRoute)
  {
    var routeStack = this.state.routeStack;
    if( routeStack.length <= 0 ) routeStack = [topRoute];
    else routeStack[routeStack.length-1] = topRoute;
    this._rightOffsets = [];
    this._leftOffsets = [];
    this._opacities = [];
    for( var i = 0; i < routeStack.length; i++ )
    {
      this._rightOffsets.push(new Animated.Value(0));
      this._leftOffsets.push(new Animated.Value(0));
      this._opacities.push(new Animated.Value(1));
    }

    this.setState({routeStack});
  },

  doPushAnim : function()
  {
    if( !this._shouldStartPushAnim ) return;
    this._shouldStartPushAnim = false;

    var thisThing = this;
    Animated.timing(this._rightOffsets[this._rightOffsets.length-1],{toValue:0, duration:ANIM_DURATION}).start(()=>
    {
    })
    Animated.timing(this._leftOffsets[this._leftOffsets.length-1],{toValue:0, duration:ANIM_DURATION}).start(()=>
    {
    })
    Animated.timing(this._opacities[this._opacities.length-2],{toValue:0, duration:ANIM_DURATION/2}).start(()=>
    {
      Animated.timing(thisThing._opacities[thisThing._opacities.length-1],{toValue:1, duration:ANIM_DURATION/2}).start(()=>
      {
      })
    })
  },

  render: function()
  {
    if( this.state.routeStack.length <= 0 ) return null;

    var thisThing = this;

    var currentIndex = this.state.routeStack.length-1;
    var currentRoute = this.state.routeStack[currentIndex];

    var style = [this.props.style, {height:Globals.ACTION_BAR_HEIGHT, flex:1, flexDirection:'row', alignItems:'stretch'}];
    return <View style={style}>
      <View style={{width:90, alignItems:'flex-start'}}>
      {this.props.routeMapper.LeftButton(currentRoute, this.props.nav, currentIndex, this.state)}
      </View>
      <View style={{flex:1, alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
      {
        thisThing.state.routeStack.map((route, index) =>
        {
          return <Animated.View key={"route-"+index}
            style={
              {
                position:'absolute',
                opacity:thisThing._opacities[index],
                top:0,
                bottom:0,
                left:thisThing._leftOffsets[index],
                right:thisThing._rightOffsets[index]}}>
              {this.props.routeMapper.Title(route, this.props.nav, index, this.state)}
          </Animated.View>
        })
      }
      </View>
      <View style={{width:90, alignItems:'flex-end'}}>
      {this.props.routeMapper.RightButton(currentRoute, this.props.nav, currentIndex, this.state)}
      </View>
    </View>
  }
});

module.exports = Navigator;



// WEBPACK FOOTER //
// ./src/wrappers/Navigator-wrapper.js